import React from "react";
import {
  Grid2,
  Card,
  Divider
} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import { Link } from "react-router-dom";
import { Branch } from "../../../interfaces/entities/branch";
import * as S from "./branchListView.styles";
import { Collection } from "../../../enums/collections.enum";

interface BranchListViewPresentationalProps {
  branches: Branch[];
  companyId: string;
}

export const BranchListViewPresentational: React.FC<BranchListViewPresentationalProps> = ({
  companyId,
  branches
}) => {

  return (
    <>
     <Divider>Company Branches</Divider>
      <Grid2 container spacing={2} sx={{ padding: 2 }} >
        {branches.map((branch) => (
          <Grid2 key={branch.id} size={{ xs: 12, sm: 6, md: 4 }}>
            <Card elevation={2} sx={{ background: 'transparent' }}>
              <Link to={`/${Collection.Companies}/${companyId}/${Collection.Branches}/${branch.id}`} style={{ display: "flex", textDecoration: "none", width: "100%", height: '150px' }}>

                <S.BranchImageWrapper>
                  <S.BranchImage
                    src={branch.image || "/assets/default-branch.jpg"}
                    alt={branch.name}
                  />
                </S.BranchImageWrapper>

                {/* Branch Info */}
                <S.BranchInfo sx={{ background: '#FFFFFF20' }}>
                  <S.BranchName variant="h6">
                    {branch.name}
                  </S.BranchName>
                  {/* <S.BranchMetaFirst variant="body2">
                    <LocationOnIcon sx={{ fontSize: 16, mr: 0.5, color: "#666" }} />
                    {branch.address || "Address not available"}
                  </S.BranchMetaFirst> */}
                  <S.BranchMeta variant="body2">
                    <PhoneIcon sx={{ fontSize: 16, mr: 0.5, color: "#666" }} />
                    {branch.phone || "Not available"}
                  </S.BranchMeta>
                  {/* <S.BranchMeta variant="body2">
                    <EmailIcon sx={{ fontSize: 16, mr: 0.5, color: "#666" }} />
                    {branch.email || "Not available"}
                  </S.BranchMeta> */}
                </S.BranchInfo>
              </Link>
            </Card>
          </Grid2>
        ))}
      </Grid2>
    </>
  );
};

